import { useState, useCallback, useRef, useEffect } from "react";

import Alert from "ui-components/Alert";
import Divider from "ui-components/Divider";

import config from "config";
import { useGetFetcher } from "api";

import { fetchProfile } from "../api";
import { useUserDetails, useLoginProgress } from "../auth-state";
import EmailLogin from "../components/Email-Login-Form";

import { useInitFirebase } from "./init-firebase";
import emailAuth from "./email-auth";
import GoogleLogin from "./Google-Login";

type SubmitStatus = "not-started" | "submitting" | "complete";

function SignIn() {
  const [loginInProgress] = useLoginProgress();
  const mounted = useRef(true);
  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  });
  useInitFirebase();
  const fetcher = useGetFetcher();
  const [, updateUserDetails] = useUserDetails();

  const [selectedMethod, setSelectedMethod] = useState<"email" | "google">();
  const [submitStatus, setSubmitStatus] = useState<SubmitStatus>("not-started");
  const [createSuccess, setCreateSuccess] = useState<boolean>(true);
  const [errorMessage, setErrorMessage] = useState<string>();

  const resetSubmitStatus = useCallback(() => {
    if (mounted.current) {
      if (submitStatus !== "not-started") {
        setSubmitStatus("not-started");
      }
    }
  }, [submitStatus, setSubmitStatus]);

  if (loginInProgress) {
    return (
      <p className="font-bold text-xl text-center">Fetching your details...</p>
    );
  }

  return (
    <>
      <EmailLogin
        createSuccess={createSuccess}
        setCreateSuccess={setCreateSuccess}
        submitStatus={submitStatus}
        setSubmitStatus={setSubmitStatus}
        errorMessage={errorMessage}
        setErrorMessage={setErrorMessage}
        resetSubmitStatus={resetSubmitStatus}
        resetPasswordLink={
          config.DISALLOW_SOCIAL_LOGINS ? null : "/reset-password"
        }
        onSubmit={async (email, password) => {
          setSelectedMethod("email");
          const resp = await emailAuth(email, password);

          if (resp?.success) {
            const firebaseUser = await fetchProfile(fetcher);
            updateUserDetails(firebaseUser);
          }

          return resp;
        }}
      />
      {!config.DISALLOW_SOCIAL_LOGINS && (
        <>
          <Divider>Or</Divider>
          {selectedMethod === "google" &&
            submitStatus === "complete" &&
            createSuccess === false && <Alert>{errorMessage}</Alert>}
          <div className="flex flex-wrap -mx-3">
            <div className="w-full px-3">
              <GoogleLogin />
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default SignIn;
